import { render, staticRenderFns } from "./viewOrderStatusLogDialog.vue?vue&type=template&id=788be6e9&scoped=true"
import script from "./viewOrderStatusLogDialog.vue?vue&type=script&lang=ts"
export * from "./viewOrderStatusLogDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788be6e9",
  null
  
)

export default component.exports